<template>
    <div>
        <loading
            :active.sync="loading.app"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{ name: 'account' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Info Usaha</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" v-if="loading.app == false">
            <div class="section inset mt-2">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="label">Nama Usaha</label>
                        <input
                            type="text"
                            class="form-control text-capitalize"
                            v-model="businessData.businessName"
                            style="font-size: 13px"
                        />
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="label">Jenis Usaha</label>

                        <select
                            name=""
                            class="form-control"
                            v-model="businessData.businessType"
                            style="font-size: 13px; padding: 0px 15px 0px 10px"
                        >
                            <option value="" disabled selected>
                                - Pilih -
                            </option>
                            <option value="Toko Kelontong">
                                Toko Kelontong
                            </option>
                            <option value="Warung Sembako">
                                Warung Sembako
                            </option>
                            <option value="Konter Pulsa">Konter Pulsa</option>
                            <option value="Agen Pembayaran">
                                Agen Pembayaran
                            </option>
                            <option value="Lainnya">Lainnya</option>
                        </select>
                    </div>
                </div>
                <div class="form-group boxed">
                    <label class="label">Foto Usaha (tampak luar)</label>
                    <div class="d-flex flex-column align-items-center">
                        <label
                            for="file-input"
                            class="w-100"
                            style="background-color: #f3f4f5"
                        >
                            <div
                                class="border rounded bg-light text-center overflow-hidden"
                                style="height: 180px; cursor: pointer"
                            >
                                <div
                                    v-if="businessData.imageOutlet"
                                    class="h-100 w-100"
                                >
                                    <img
                                        :src="
                                            businessData.imageOutletBase64 ==
                                            true
                                                ? businessData.imageOutlet
                                                : VUE_ENV.VUE_APP_ASSET_URL +
                                                  '/storage/image/customer-business/' +
                                                  businessData.imageOutlet
                                        "
                                        alt="Preview"
                                        class="h-100 w-100"
                                        style="object-fit: cover"
                                    />
                                </div>
                                <div v-else class="text-secondary p-4">
                                    <ion-icon
                                        name="camera"
                                        style="font-size: 64px; color: grey"
                                        class="text-grey"
                                    ></ion-icon>
                                    <p class="mb-0">
                                        <small
                                            >Klik di sini untuk ambil
                                            foto</small
                                        >
                                    </p>
                                </div>
                            </div>
                        </label>
                        <input
                            type="file"
                            id="file-input"
                            accept="image/*"
                            v-on:change="onImageChange"
                            class="d-none"
                        />
                    </div>
                </div>
                <!-- Lokasi Usaha -->
                <div class="form-group boxed">
                    <label class="label">Lokasi Usaha</label>
                    <div id="map-container">
                        <div id="map" class="rounded border"></div>
                        <!-- Marker Tetap -->
                        <div id="marker" :style="markerStyle"></div>

                        <router-link
                            :to="{
                                name: 'maps',
                                params: {
                                    referenceDataLocation:
                                        businessData.mapsLocationData,
                                    referencePage: 'account.business',
                                },
                            }"
                            class="btn text-dark fw-bold position-absolute"
                            id="ubah-lokasi-btn"
                        >
                            Ubah Titik Lokasi
                        </router-link>
                    </div>
                </div>
                <!-- Detail Usaha -->
                <div class="form-group">
                    <div
                        class="mt-1"
                        v-if="
                            businessData.mapsLocationData.address != '' &&
                            businessData.mapsLocationData.subAddress != ''
                        "
                    >
                        <h5 class="fw-bold mb-1">
                            {{ businessData.mapsLocationData.address }}
                        </h5>
                        <p style="line-height: 15px; font-size: 11px">
                            {{ businessData.mapsLocationData.subAddress }}
                        </p>
                    </div>
                    <div v-else>
                        <p style="line-height: 15px; font-size: 11px">
                            Tentukan titik lokasi usaha terlebih dahulu
                        </p>
                    </div>
                </div>
                <!-- Detail Alamat -->
                <div class="form-group boxed">
                    <label class="label">Detail Alamat</label>
                    <textarea
                        class="form-control"
                        style="font-size: 13px"
                        v-model="businessData.addressDetail"
                        placeholder="Masukkan detail alamat dan patokan"
                    ></textarea>
                    <small>Contoh : no. rumah, blok, Rt/RW, pagar putih</small>
                </div>
                <div class="form-group basic">
                    <button
                        class="btn btn-primary btn-block btn-lg"
                        @click="showDialog('show')"
                    >
                        Simpan
                    </button>
                </div>
            </div>
        </div>

        <Dialog
            ref="dialog"
            :loading="dialogLoading"
            :title="'Simpan'"
            @confirm="submit()"
        >
            <p>Anda yakin akan merubah informasi usaha?</p>
        </Dialog>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex';
    import $axios from '../../api.js';
    import { Loader } from '@googlemaps/js-api-loader';
    export default {
        name: 'account.business',
        props: ['referenceDataLocation'],
        data() {
            return {
                dialogLoading: false,
                map: null,
                markerImage: require('@/assets/maker.svg'),
            };
        },
        mounted() {
            // Jika ada data referensi
            if (this.referenceDataLocation) {
                this.businessData.mapsLocationData = this.referenceDataLocation;
                this.loading.app = false;
            } else {
                this.getBusinessData().then(() => {
                    this.loading.app = false;
                });
            }
            if (!this.loading.app) {
                this.initGoogleMaps();
            }
        },
        created() {},
        computed: {
            ...mapState(['customer', 'loading', 'toast', 'VUE_ENV']),
            ...mapState('accountBusiness', ['businessData']),
            markerStyle() {
                return {
                    position: 'absolute',
                    top: '45%',
                    left: '50%',
                    transform: 'translate(-50%, -90%)',
                    height: '46px',
                    width: '33px',
                    background: `url(${this.markerImage}) no-repeat center`,
                    backgroundSize: 'contain',
                    pointerEvents: 'none',
                };
            },
        },
        methods: {
            ...mapActions('accountBusiness', ['getBusinessData']),
            initGoogleMaps() {
                const loader = new Loader({
                    apiKey: this.VUE_ENV.VUE_APP_GMAPS_APIKEY,
                    libraries: ['places'],
                });

                loader.load().then(() => {
                    this.initMap();
                });
            },
            initMap() {
                const mapElement = document.getElementById('map');

                // Inisialisasi peta
                this.map = new google.maps.Map(mapElement, {
                    center: {
                        lat: this.businessData.mapsLocationData.latitude,
                        lng: this.businessData.mapsLocationData.longitude,
                    },
                    zoom: 16,
                    gestureHandling: 'none', // Nonaktifkan semua interaksi (geser, zoom, dll.)
                    disableDefaultUI: true, // Nonaktifkan kontrol UI bawaan (zoom, peta, dll.)
                    draggable: false, // Nonaktifkan penggeseran peta
                    scrollwheel: false, // Nonaktifkan zoom dengan roda gulir
                });

                // Menonaktifkan Info Window pada POI
                this.map.addListener('click', event => {
                    if (event.placeId) {
                        // Hentikan aksi default jika klik pada POI
                        event.stop();
                    }
                });
            },
            onImageChange(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
                this.createImage(files[0]);
                this.businessData.imageOutletBase64 = true;
            },
            createImage(file) {
                let reader = new FileReader();
                let vm = this;
                reader.onload = e => {
                    vm.businessData.imageOutlet = e.target.result;
                };
                reader.readAsDataURL(file);
            },
            showDialog(value) {
                let element = this.$refs.dialog.$el;
                window.$(element).modal(value);
            },
            submit() {
                this.dialogLoading = true;
                $axios
                    .patch('/customer/business', this.businessData)
                    .then(response => {
                        this.showDialog('hide');
                        this.dialogLoading = false;
                        this.getBusinessData();
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: response.data.message,
                            tipe: 'default',
                            icon: 'success',
                        });
                    })
                    .catch(error => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                        this.showDialog('hide');
                        this.dialogLoading = false;
                    });
            },
        },
        watch: {
            'loading.app'(newValue) {
                if (!newValue) {
                    this.initGoogleMaps();
                }
            },
        },
        destroyed() {
            this.$store.commit('RESET_LOADING');
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
<style scoped>
    #map-container {
        position: relative; /* Parent harus memiliki posisi relative */
        width: 100%; /* Lebar peta */
        height: 150px; /* Tinggi peta */
    }

    #ubah-lokasi-btn {
        position: absolute;
        top: 50%; /* Tempatkan di tengah vertikal */
        left: 50%; /* Tempatkan di tengah horizontal */
        transform: translate(
            -50%,
            5px
        ); /* Geser sedikit ke bawah dari marker */
        z-index: 11; /* Lebih tinggi dari peta */
        background-color: white; /* Tambahkan warna background */
        border: 1px solid #ddd; /* Tambahkan border */
        border-radius: 5px; /* Tambahkan border-radius */
        padding: 5px 10px; /* Padding tombol */
        font-weight: bold; /* Teks tombol lebih tebal */
        cursor: pointer; /* Ubah kursor menjadi pointer */
    }

    #map {
        height: 150px;
        position: relative;
        overflow: hidden;
    }
</style>
